import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Loading service
 */
@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  // Whether app is loaded initially or not
  private _appLoading = new BehaviorSubject<boolean>(true);

  // Whether router is loaded or not
  private _routerLoading = new BehaviorSubject<boolean>(true);

  constructor() {
    this._appLoading = new BehaviorSubject<boolean>(true);
  }

  setAppLoading = _.throttle((loading: boolean) => {
    this._appLoading.next(loading);
  }, 50);

  setRouterLoading = _.throttle((loading: boolean) => {
    this._routerLoading.next(loading);
  }, 50);

  get appLoading(): Observable<boolean> {
    return this._appLoading.asObservable();
  }

  get routerLoading(): Observable<boolean> {
    return this._routerLoading.asObservable();
  }
}
